import {useState} from 'react';
import {NavLink} from 'react-router-dom';
import './HeaderComponent.scss';

const HeaderComponent = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="header">
            <div className="header__inner">
                <div className="header__logo">
                    <img src="/assets/icons/logo-bg.jpeg" alt="Basin Authority" />
                    <img className='ministry' src="/assets/icons/Logo_ME_en-removebg-preview.png" alt="Ministry of Environment" />
                </div>

                <div className="header__title">Онлайн-платформа "Рось"</div>

                <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
                    <NavLink
                        to="/"
                        className={({isActive}) => `header__link ${isActive ? 'header__link--active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                    >
                        Мапа
                    </NavLink>
                    <NavLink
                        to="/plans"
                        className={({isActive}) => `header__link ${isActive ? 'header__link--active' : ''}`}
                        onClick={() => setMenuOpen(false)}
                    >
                        План дій
                    </NavLink>
                </nav>

                <button
                    className={`header__burger ${menuOpen ? 'header__burger--open' : ''}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Toggle menu"
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>
        </header>
    );
};

export default HeaderComponent;
